module.exports = __webpack_public_path__ + "media/images/linkedin-e707e3603b0d85cbecd25918815a0458.svg";